export const data = [
  {
    cur: 997494,
    goal: 50000,
    donors: "32.9K",
    created: "March 18, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/2b8zh292uo",
  },
  {
    cur: 353800,
    goal: 50000,
    donors: "5.1K",
    created: "February 28, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-yong-zheng-family-to-get-thru-this",
  },
  {
    cur: 270458,
    goal: 20000,
    donors: "6.5K",
    created: "March 31, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-and-support-we-are-with-you-vilma-kari",
  },
  {
    cur: 96441,
    goal: 250000,
    donors: "149",
    created: "March 4, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/stopasianhatehalloffame",
  },
  {
    cur: 94842,
    goal: 100000,
    donors: "1.7K",
    created: "March 11, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/stop-the-hate-crime-chak-keung-chan-badly-beaten",
  },
  {
    cur: 93232,
    goal: 95000,
    donors: "2.1K",
    created: "February 17, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/assist-with-marcs-medical-expenses",
  },
  {
    cur: 91147,
    goal: 10000,
    donors: "3K",
    created: "February 1, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/84yearold-killed-in-san-francisco",
  },
  {
    cur: 78055,
    goal: 250000,
    donors: "1.2K",
    created: "December 22, 2020",
    section: "Justice",
    url: "https://www.gofundme.com/f/GuanShuai",
  },
  {
    cur: 53100,
    goal: 100000,
    donors: "1.5K",
    created: "February 27, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-noel-quintana",
  },
  {
    cur: 47483,
    goal: 35000,
    donors: "1.2K",
    created: "March 9, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/support-inglemoor-hs-teacher-noriko-nasu",
  },
  {
    cur: 42131,
    goal: 25000,
    donors: "1K",
    created: "March 22, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/the-nguyen-fundraiser",
  },
  {
    cur: 26708,
    goal: 50000,
    donors: "449",
    created: "February 11, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/sf-api-victims-and-survivors-assistance-fund",
  },
  {
    cur: 17816,
    goal: 2000,
    donors: "501",
    created: "March 22, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-oriental-pantry-after-break-in-and-burglary",
  },
  {
    cur: 14135,
    goal: 15000,
    donors: "317",
    created: "March 18, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/yume-gelato-justice",
  },
  {
    cur: 12894,
    goal: 12000,
    donors: "276",
    created: "February 24, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-jaydens-medical-bills-from-hate-crime",
  },
  {
    cur: 10669,
    goal: 50000,
    donors: "86",
    created: "March 4, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-zheng-yong-the-good-samaritan",
  },
  {
    cur: 9489,
    goal: 8888,
    donors: "352",
    created: "February 12, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/kft-columbia-for-stop-aapi-hate",
  },
  {
    cur: 8655,
    goal: 10000,
    donors: "141",
    created: "March 22, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/11yearold-asian-girl-held-in-sf-home-invasion",
  },
  {
    cur: 6924,
    goal: 5000,
    donors: "199",
    created: "February 12, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-my-family-after-home-burglary",
  },
  {
    cur: 6680,
    goal: 5000,
    donors: "170",
    created: "March 23, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/burglary-of-pineapple-king-bakery",
  },
  {
    cur: 4215,
    goal: 10000,
    donors: "75",
    created: "March 30, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-move-yong-choi-to-a-safe-home-free-from-hate",
  },
  {
    cur: 3535,
    goal: 3000,
    donors: "90",
    created: "February 19, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/utopia-restaurant-and-lounge-vandalism-damages",
  },
  {
    cur: 565117,
    goal: 50000,
    donors: "10.9K",
    created: "April 25, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-yao-pan-ma",
  },
  {
    cur: 532525,
    goal: 1,
    donors: "13.2K",
    created: "April 16, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/eqn24y-help-nafiah-acid-attack-survivor-get-justice",
  },
  {
    cur: 296516,
    goal: 20000,
    donors: "5.8K",
    created: "April 27, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/in-loving-memory-of-shane-nguyen",
  },
  {
    cur: 134704,
    goal: 50000,
    donors: "3.2K",
    created: "May 5, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/exvd5-help-my-grandma-with-medical-bills",
  },
  {
    cur: 84722,
    goal: 15000,
    donors: "1.1K",
    created: "April 26, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/in-the-loving-memory-of-john-huynh",
  },
  {
    cur: 56790,
    goal: 50000,
    donors: "1K",
    created: "April 5, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/qd4fh-justice-for-ke-chieh-meng",
  },
  {
    cur: 48393,
    goal: 5000,
    donors: "1K",
    created: "April 1, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/enough-stop-hate-crime-on-asian-small-business",
  },
  {
    cur: 48251,
    goal: 25000,
    donors: "1.3K",
    created: "April 13, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/chi-ling-lee-fundraiser",
  },
  {
    cur: 35359,
    goal: 30000,
    donors: "787",
    created: "March 30, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/mr-chheng-car-engulfed-in-flames",
  },
  {
    cur: 34460,
    goal: 15000,
    donors: "481",
    created: "April 20, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/stop-aapi-hate-liem-tran-assaulted-robbed",
  },
  {
    cur: 32164,
    goal: 3000,
    donors: "1.2K",
    created: "May 13, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-paul-raise-money-to-see-a-doctor",
  },
  {
    cur: 20820,
    goal: 5000,
    donors: "552",
    created: "June 3, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-my-dad-recover-from-sustained-injuries",
  },
  {
    cur: 19660,
    goal: 70000,
    donors: "226",
    created: "June 21, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/nhn28-help-family-business",
  },
  {
    cur: 12710,
    goal: 10000,
    donors: "408",
    created: "April 13, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/cover-jennas-medical-bills-and-fund-self-defense",
  },
  {
    cur: 8474,
    goal: 1250,
    donors: "296",
    created: "April 14, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-the-gourmet-house-repair-their-window",
  },
  {
    cur: 6780,
    goal: 3000,
    donors: "162",
    created: "May 15, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-lincoln-district-businesses-with-repairs",
  },
  {
    cur: 4080,
    goal: 2000,
    donors: "94",
    created: "June 7, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/utah-food-truck-vandalized-with-hate-messages",
  },
  {
    cur: 4007,
    goal: 5000,
    donors: "98",
    created: "June 22, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/armed-robbery-carjacking-and-kidnapping-of-asian",
  },
  {
    cur: 3800,
    goal: 20000,
    donors: "53",
    created: "May 16, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-for-monterey-pizza-asian-zap-sf",
  },
  {
    cur: 3491,
    goal: 7500,
    donors: "79",
    created: "June 27, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/help-dim-sum-corner-repair-two-smashed-windows",
  },
  {
    cur: 2018,
    goal: 5000,
    donors: "44",
    created: "March 31, 2021",
    section: "Justice",
    url: "https://www.gofundme.com/f/rebuildourfamilyrestaurant",
  },
  {
    cur: 251095,
    goal: 100000,
    donors: "74",
    created: "March 2, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/oakland-chinatown-safety-fund",
  },
  {
    cur: 110698,
    goal: 80000,
    donors: "1.5K",
    created: "February 5, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/securityforoaklandchinatown",
  },
  {
    cur: 94268,
    goal: 100000,
    donors: "1.3K",
    created: "February 20, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/stopasianhate",
  },
  {
    cur: 46291,
    goal: 30000,
    donors: "847",
    created: "October 9, 2020",
    section: "Safety",
    url: "https://www.gofundme.com/f/how-to-report-a-hate-crime-booklet-printing-fund",
  },
  {
    cur: 30523,
    goal: 75000,
    donors: "310",
    created: "March 22, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/camerasforoaklandchinatown",
  },
  {
    cur: 29024,
    goal: 210000,
    donors: "534",
    created: "February 17, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/safewalksapp",
  },
  {
    cur: 26084,
    goal: 20000,
    donors: "220",
    created: "March 20, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/2tc75h-stopasianhate-with-safe-from-hate-safety-alarms",
  },
  {
    cur: 25506,
    goal: 30000,
    donors: "289",
    created: "March 25, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/alarms-pepper-spray-for-aapi-seniors-and-women",
  },
  {
    cur: 20405,
    goal: 20000,
    donors: "190",
    created: "March 24, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/aapi-senior-safety-initiative-la",
  },
  {
    cur: 16003,
    goal: 20000,
    donors: "223",
    created: "February 12, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/in-the-mood-for-love-not-hate",
  },
  {
    cur: 7722,
    goal: 8500,
    donors: "197",
    created: "April 8, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/safety-alarms-for-asians-in-nyc",
  },
  {
    cur: 7355,
    goal: 10000,
    donors: "74",
    created: "March 31, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/protect-chinatown",
  },
  {
    cur: 6795,
    goal: 6000,
    donors: "89",
    created: "March 26, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/aapi-senior-citizen-selfdefense-initiative",
  },
  {
    cur: 5808,
    goal: 8500,
    donors: "94",
    created: "March 30, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/help-elderly-asian-americans-in-boston",
  },
  {
    cur: 5516,
    goal: 5500,
    donors: "67",
    created: "March 19, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/help-asian-seniors-stay-safe-in-san-francisco",
  },
  {
    cur: 4301,
    goal: 5000,
    donors: "53",
    created: "March 19, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/protect-our-elders",
  },
  {
    cur: 4162,
    goal: 2000,
    donors: "52",
    created: "September 9, 2020",
    section: "Safety",
    url: "https://www.gofundme.com/f/protect-sf-chinatown-united-peace-collaborative",
  },
  {
    cur: 3099,
    goal: 7000,
    donors: "73",
    created: "February 9, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/protecting-the-asian-community-and-elderly",
  },
  {
    cur: 3035,
    goal: 4000,
    donors: "55",
    created: "April 1, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/help-get-the-aapi-elders-in-sd-safety-tools",
  },
  {
    cur: 2846,
    goal: 5000,
    donors: "45",
    created: "March 31, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/selfdefense-courses-for-the-aapi-communityallies",
  },
  {
    cur: 2703,
    goal: 5000,
    donors: "52",
    created: "March 20, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/self-defense-for-asian-community-in-bay-area",
  },
  {
    cur: 2275,
    goal: 3500,
    donors: "68",
    created: "February 15, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/selfdefense-packages-for-aapi",
  },
  {
    cur: 1490,
    goal: 5000,
    donors: "23",
    created: "April 6, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/c8hm7a-stop-asian-hate",
  },
  {
    cur: 1277,
    goal: 2000,
    donors: "15",
    created: "April 3, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/dmmck-personal-safety-devices-for-asian-elderly-sa-tx",
  },
  {
    cur: 0,
    goal: 25000,
    donors: "Donation",
    created: "March 24, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/help-keep-aapi-community-safe-in-your-neighborhood",
  },
  {
    cur: 17649,
    goal: 20000,
    donors: "449",
    created: "April 10, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/recognizing-samba-guisse-my-job-is-just-to-help",
  },
  {
    cur: 15376,
    goal: 15000,
    donors: "286",
    created: "April 30, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/Repair-Chinatown-Our-Asian-Community",
  },
  {
    cur: 6695,
    goal: 8168,
    donors: "55",
    created: "May 27, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/chinatown-sentries-patrol-without-the-politics",
  },
  {
    cur: 3777,
    goal: 4000,
    donors: "70",
    created: "May 20, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/alarms-and-pepper-spray-for-chicago-asian-seniors",
  },
  {
    cur: 3310,
    goal: 5000,
    donors: "44",
    created: "April 14, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/saafeorg-los-angeles",
  },
  {
    cur: 2621,
    goal: 5000,
    donors: "46",
    created: "April 13, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/safety-kits-for-aapi-community",
  },
  {
    cur: 2101,
    goal: 5000,
    donors: "47",
    created: "June 3, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/protect-the-boston-elderly-asian-community",
  },
  {
    cur: 1210,
    goal: 1000,
    donors: "22",
    created: "May 6, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/pepper-spray-for-asian-selfdefense",
  },
  {
    cur: 1195,
    goal: 1,
    donors: "24",
    created: "April 30, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/fundraiser-for-main-street-patrol",
  },
  {
    cur: 500,
    goal: 1000,
    donors: "14",
    created: "April 11, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/help-keep-aapis-safe",
  },
  {
    cur: 297,
    goal: 3000,
    donors: "7",
    created: "April 9, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/spray-out-the-hate",
  },
  {
    cur: 210,
    goal: 210,
    donors: "12",
    created: "April 13, 2021",
    section: "Safety",
    url: "https://www.gofundme.com/f/protect-aaip-ensure-safe-transportation",
  },
  {
    cur: 82366,
    goal: 80000,
    donors: "1.3K",
    created: "February 23, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/qwajf-save-spoon-by-h",
  },
  {
    cur: 40217,
    goal: 60000,
    donors: "460",
    created: "March 27, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/emergency-stirfry-mealsonwheels-for-seniors",
  },
  {
    cur: 18508,
    goal: 18000,
    donors: "182",
    created: "July 3, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/w4wwoks-for-washington",
  },
  {
    cur: 17747,
    goal: 168000,
    donors: "196",
    created: "April 27, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/fighting-covid19-antiasian-racism-with-research",
  },
  {
    cur: 17418,
    goal: 17500,
    donors: "270",
    created: "March 14, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/k5u62p-covid19-mutual-aid-network-api-la",
  },
  {
    cur: 17095,
    goal: 10000,
    donors: "29",
    created: "April 15, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/funding-openmeal",
  },
  {
    cur: 12110,
    goal: 35000,
    donors: "108",
    created: "August 26, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/support-the-aacc",
  },
  {
    cur: 10781,
    goal: 40000,
    donors: "15",
    created: "April 3, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/Donate3AF",
  },
  {
    cur: 9335,
    goal: 6000,
    donors: "70",
    created: "February 22, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/figma-antiasian-violence-relief-fundraiser-drive",
  },
  {
    cur: 8335,
    goal: 350000,
    donors: "110",
    created: "January 26, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/our-league-of-dreams-jacl-documentary",
  },
  {
    cur: 4482,
    goal: 15000,
    donors: "69",
    created: "June 22, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/youthled-mutual-aid-project-fund",
  },
  {
    cur: 4053,
    goal: 5000,
    donors: "119",
    created: "February 5, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-stop-violence-and-hate-against-asians",
  },
  {
    cur: 3170,
    goal: 3000,
    donors: "32",
    created: "January 18, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/the-asian-american-dream",
  },
  {
    cur: 2751,
    goal: 3500,
    donors: "38",
    created: "September 10, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/zuckv-rgrg",
  },
  {
    cur: 2675,
    goal: 10000,
    donors: "54",
    created: "February 6, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/asian-businesses-and-families-in-the-bay-area",
  },
  {
    cur: 2545,
    goal: 2500,
    donors: "34",
    created: "February 12, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-raise-funds-for-oppressed-asian-americans",
  },
  {
    cur: 2045,
    goal: 20000,
    donors: "18",
    created: "February 8, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/mutual-aid-to-support-karolyn-wong",
  },
  {
    cur: 1510,
    goal: 25000,
    donors: "19",
    created: "June 8, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/aaccgp-smallbusiness-recoveryfund",
  },
  {
    cur: 1245,
    goal: 2001,
    donors: "42",
    created: "February 23, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/lantern-festival-of-hope",
  },
  {
    cur: 1095,
    goal: 750,
    donors: "26",
    created: "September 10, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/preserving-the-stories-of-asian-american-farmers",
  },
  {
    cur: 864,
    goal: 1000,
    donors: "32",
    created: "October 3, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/assisting-asians-impacted-by-pandemic",
  },
  {
    cur: 350,
    goal: 2500,
    donors: "10",
    created: "September 26, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/campaign-for-areaa-education-foundation",
  },
  {
    cur: 81393,
    goal: 152000,
    donors: "1.5K",
    created: "March 17, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/AAPI-journalists-therapy-relief-fund",
  },
  {
    cur: 46489,
    goal: 5000,
    donors: "274",
    created: "February 26, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/createtostophate",
  },
  {
    cur: 41145,
    goal: 50000,
    donors: "101",
    created: "December 20, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/SaveRoyalEast",
  },
  {
    cur: 25440,
    goal: 70000,
    donors: "63",
    created: "August 12, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/chsa039s-purchase-of-artist-jake-lee-paintings",
  },
  {
    cur: 25210,
    goal: 30000,
    donors: "633",
    created: "March 15, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/support-our-elderly-and-fight-antiasian-violence",
  },
  {
    cur: 15380,
    goal: 15000,
    donors: "163",
    created: "March 5, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-nutes-noodles-of-bernal-heights",
  },
  {
    cur: 14797,
    goal: 30000,
    donors: "230",
    created: "March 5, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-turn-awa-into-a-501c3-nonprofit",
  },
  {
    cur: 10134,
    goal: 10000,
    donors: "138",
    created: "December 11, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-a-qtapiled-farm-levelup",
  },
  {
    cur: 9971,
    goal: 6000,
    donors: "79",
    created: "March 17, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/evernation-stop-aapi-hate-fund",
  },
  {
    cur: 8343,
    goal: 18871,
    donors: "156",
    created: "May 31, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/noodle-tree-community-fund",
  },
  {
    cur: 8227,
    goal: 7500,
    donors: "94",
    created: "March 17, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-us-stop-asian-hate",
  },
  {
    cur: 8181,
    goal: 20000,
    donors: "90",
    created: "June 24, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/BestDonuts",
  },
  {
    cur: 7315,
    goal: 10000,
    donors: "39",
    created: "June 7, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/chopsticks-for-change",
  },
  {
    cur: 5351,
    goal: 5000,
    donors: "81",
    created: "March 5, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-fund-stop-asian-hate-boston-rally",
  },
  {
    cur: 5330,
    goal: 5000,
    donors: "88",
    created: "March 4, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/virtual-10k-to-stopasianhate",
  },
  {
    cur: 5137,
    goal: 10000,
    donors: "157",
    created: "March 17, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/kids-bookstagram-against-aapi-hate",
  },
  {
    cur: 3775,
    goal: 10000,
    donors: "54",
    created: "March 17, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/raise-money-to-stop-aapi-hate",
  },
  {
    cur: 2112,
    goal: 2000,
    donors: "57",
    created: "March 16, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/t8dkx-stop-xenophobia-support-our-api-community",
  },
  {
    cur: 2050,
    goal: 7500,
    donors: "14",
    created: "February 15, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-asian-woman-compete-in-miss-ca-usa",
  },
  {
    cur: 1010,
    goal: 250,
    donors: "21",
    created: "February 23, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-aalsa-raise-money-to-assist-pwjc-clients",
  },
  {
    cur: 620,
    goal: 15000,
    donors: "8",
    created: "November 18, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/asianweekdb",
  },
  {
    cur: 550,
    goal: 200,
    donors: "34",
    created: "February 26, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/support-jordans-i-am-not-a-virus-album-release",
  },
  {
    cur: 285,
    goal: 700,
    donors: "8",
    created: "August 21, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/fcps-apac-coalition-scholarship",
  },
  {
    cur: 200,
    goal: 200,
    donors: "6",
    created: "November 30, 2020",
    section: "Uplift",
    url: "https://www.gofundme.com/f/2xwsru-jasmine039s-campaign-aaaj",
  },
  {
    cur: 110023,
    goal: 100000,
    donors: "987",
    created: "March 19, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/asianwomenalliance",
  },
  {
    cur: 57700,
    goal: 250000,
    donors: "41",
    created: "March 25, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/amoa-aapi-advocacy-fund",
  },
  {
    cur: 28196,
    goal: 500000,
    donors: "206",
    created: "March 20, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/chinese-american-legal-defense-alliance",
  },
  {
    cur: 13948,
    goal: 20000,
    donors: "94",
    created: "March 25, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/wc58t-conductor-aapi-awareness-fundraiser",
  },
  {
    cur: 13648,
    goal: 25000,
    donors: "46",
    created: "March 25, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/support-for-asian-american-pacific-islander-elders",
  },
  {
    cur: 13241,
    goal: 10000,
    donors: "212",
    created: "March 27, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/stop-asian-hate-fundraiser",
  },
  {
    cur: 7941,
    goal: 15000,
    donors: "148",
    created: "March 30, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/2swv7-stopasianhate",
  },
  {
    cur: 5100,
    goal: 7500,
    donors: "105",
    created: "March 17, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/stop-asian-hate-and-give-back-instead",
  },
  {
    cur: 3855,
    goal: 3500,
    donors: "66",
    created: "March 23, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/kftyuy-stopasianhate",
  },
  {
    cur: 3211,
    goal: 5000,
    donors: "54",
    created: "March 29, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/fight-against-antiasian-violence-dmv",
  },
  {
    cur: 2633,
    goal: 1000,
    donors: "78",
    created: "March 23, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/buying-supplies-from-asian-businesses-for-protest",
  },
  {
    cur: 2485,
    goal: 2000,
    donors: "47",
    created: "March 30, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/epic-sf-aapi-fundraiser",
  },
  {
    cur: 2405,
    goal: 2500,
    donors: "62",
    created: "March 29, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/dalins-haircut-to-advance-asian-american-justice",
  },
  {
    cur: 2286,
    goal: 10000,
    donors: "25",
    created: "March 23, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/Upstate-aapi",
  },
  {
    cur: 2145,
    goal: 5000,
    donors: "30",
    created: "March 26, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/asian-women-care-packages",
  },
  {
    cur: 2130,
    goal: 1000,
    donors: "38",
    created: "March 23, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/support-the-asian-elderly-community-with-cpacs",
  },
  {
    cur: 2080,
    goal: 5000,
    donors: "11",
    created: "March 23, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/stopasianhatega",
  },
  {
    cur: 1980,
    goal: 15000,
    donors: "25",
    created: "March 25, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/matching-for-aapi-initiatives-and-communities",
  },
  {
    cur: 1880,
    goal: 1550,
    donors: "46",
    created: "March 25, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/texas-stopasainhate-rally",
  },
  {
    cur: 1120,
    goal: 5000,
    donors: "12",
    created: "March 23, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/xuz7h-help-support-the-asian-community-in-la",
  },
  {
    cur: 1105,
    goal: 8888,
    donors: "19",
    created: "March 19, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/stopthehate-support-the-aapi-community",
  },
  {
    cur: 980,
    goal: 300,
    donors: "30",
    created: "March 24, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/sunrise-mvy-fundraiser-for-aaaj-atlanta",
  },
  {
    cur: 865,
    goal: 250,
    donors: "38",
    created: "March 25, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/stopaapihate-dublin-ohio",
  },
  {
    cur: 470,
    goal: 1000,
    donors: "11",
    created: "March 22, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/philly-rally-for-solidarity",
  },
  {
    cur: 420,
    goal: 10000,
    donors: "15",
    created: "March 19, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/support-the-aapi-community-northern-california",
  },
  {
    cur: 0,
    goal: 25000,
    donors: "Donation",
    created: "March 24, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-keep-aapi-community-safe-in-your-neighborhood",
  },
  {
    cur: 26624,
    goal: 25000,
    donors: "191",
    created: "March 26, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/douglas-elliman-in-support-of-aapi-community-fund",
  },
  {
    cur: 17357,
    goal: 15000,
    donors: "144",
    created: "April 4, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/be-seen-be-heard",
  },
  {
    cur: 16502,
    goal: 20000,
    donors: "165",
    created: "April 11, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/b8dtwk-columbia-business-school-stop-asian-hate",
  },
  {
    cur: 13902,
    goal: 15000,
    donors: "79",
    created: "April 4, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/your-stomach-loves-us",
  },
  {
    cur: 11406,
    goal: 25000,
    donors: "73",
    created: "March 31, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/asians-fighting-injustice-launch-fund",
  },
  {
    cur: 4801,
    goal: 3000,
    donors: "61",
    created: "March 31, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-double-down-against-asian-american-hate-crime",
  },
  {
    cur: 4686,
    goal: 3000,
    donors: "64",
    created: "March 20, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/support-organizations-to-stop-asian-hate",
  },
  {
    cur: 4015,
    goal: 5000,
    donors: "139",
    created: "April 3, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/rsthyrt",
  },
  {
    cur: 3600,
    goal: 10000,
    donors: "25",
    created: "March 29, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/support-brians-doc-film-on-asian-hate",
  },
  {
    cur: 3505,
    goal: 5000,
    donors: "22",
    created: "March 31, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/karat-cake-bake-4-asian-health-and-service-center",
  },
  {
    cur: 2741,
    goal: 20000,
    donors: "36",
    created: "April 12, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/1book1world-michigan-asian-american-book-drive",
  },
  {
    cur: 2500,
    goal: 30000,
    donors: "49",
    created: "April 15, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/2cckshv5lc",
  },
  {
    cur: 2436,
    goal: 5000,
    donors: "42",
    created: "March 28, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/crazy-talented-asiansfriends-flushing-town-hall",
  },
  {
    cur: 1900,
    goal: 1900,
    donors: "29",
    created: "April 1, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/aanhpi-graduation-sashes-for-de-anza-high-school",
  },
  {
    cur: 1685,
    goal: 5000,
    donors: "17",
    created: "March 31, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/2br53wnelc",
  },
  {
    cur: 1350,
    goal: 1000,
    donors: "17",
    created: "March 30, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/support-our-local-asian-communities",
  },
  {
    cur: 1015,
    goal: 1000,
    donors: "35",
    created: "April 2, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/will-bcc-stop-aapi-hate-call-to-action",
  },
  {
    cur: 930,
    goal: 2000,
    donors: "18",
    created: "April 14, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/newton-stands-with-aapi",
  },
  {
    cur: 600,
    goal: 10000,
    donors: "14",
    created: "March 31, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/get-chinatown-vaccinated-initiative",
  },
  {
    cur: 286,
    goal: 1000,
    donors: "5",
    created: "April 1, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/the-well-for-women-amplifying-aapi-womens-voices",
  },
  {
    cur: 194,
    goal: 1000,
    donors: "4",
    created: "April 6, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/stopping-asian-hate-through-design",
  },
  {
    cur: 165,
    goal: 500,
    donors: "6",
    created: "April 4, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/ny39m4-support-aapi-community-fund",
  },
  {
    cur: 145,
    goal: 5000,
    donors: "4",
    created: "April 1, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/antiasian-racism-art-mural-in-clarion-alley",
  },
  {
    cur: 0,
    goal: 500,
    donors: "Donation",
    created: "March 31, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/stop-aaip-racism-stamp-out-racism",
  },
  {
    cur: 355178,
    goal: 850000,
    donors: "145",
    created: "May 19, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/raceepidemic",
  },
  {
    cur: 25688,
    goal: 20000,
    donors: "555",
    created: "May 6, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/colorado-for-aapi",
  },
  {
    cur: 20360,
    goal: 20000,
    donors: "269",
    created: "May 4, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/scholarship-fund-for-aapi-mh-professional-trainees",
  },
  {
    cur: 13045,
    goal: 13000,
    donors: "185",
    created: "April 30, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-mr-deng-rebuild-his-art-gallery",
  },
  {
    cur: 11966,
    goal: 25000,
    donors: "83",
    created: "April 7, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/6nu24-meals-for-the-new-york-chinese-community-center",
  },
  {
    cur: 11402,
    goal: 40000,
    donors: "92",
    created: "May 2, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-complete-the-filipinxfoodseattle-documentar",
  },
  {
    cur: 8927,
    goal: 25000,
    donors: "33",
    created: "May 1, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/for-yous-great-aapi-elder-print-off",
  },
  {
    cur: 7349,
    goal: 20000,
    donors: "90",
    created: "May 18, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/run-for-representation",
  },
  {
    cur: 7309,
    goal: 18000,
    donors: "147",
    created: "April 13, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/support-la-cleaners-tailor",
  },
  {
    cur: 6165,
    goal: 5000,
    donors: "146",
    created: "June 14, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/ride-against-aapi-hate",
  },
  {
    cur: 5608,
    goal: 15000,
    donors: "13",
    created: "May 21, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/mark43-donations-to-stand-with-asian-americans",
  },
  {
    cur: 3515,
    goal: 25000,
    donors: "14",
    created: "April 27, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/murals-for-good-to-stopaapihate-awareness",
  },
  {
    cur: 3090,
    goal: 28000,
    donors: "33",
    created: "April 26, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-peggys-pay-rent",
  },
  {
    cur: 2760,
    goal: 5000,
    donors: "27",
    created: "May 6, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/carbon-people-of-color-erg-stop-aapi-hate",
  },
  {
    cur: 2760,
    goal: 7500,
    donors: "22",
    created: "May 8, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-preserve-chen-lok-lees-artistic-legacy",
  },
  {
    cur: 2550,
    goal: 10000,
    donors: "15",
    created: "April 15, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/aapiactionpledge",
  },
  {
    cur: 1338,
    goal: 1000,
    donors: "24",
    created: "April 15, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-raise-awareness-for-stopasianhate",
  },
  {
    cur: 1280,
    goal: 1882,
    donors: "43",
    created: "April 17, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/fx4rx-stop-aapi-hate",
  },
  {
    cur: 1035,
    goal: 2000,
    donors: "25",
    created: "May 19, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/tapas-aapi-month-donation-event",
  },
  {
    cur: 615,
    goal: 50000,
    donors: "4",
    created: "April 19, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-rai-stopasianhate",
  },
  {
    cur: 450,
    goal: 1000,
    donors: "8",
    created: "May 6, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/dc-aapi-coalition-for-chefs-stopping-aapi-hate",
  },
  {
    cur: 360,
    goal: 1000,
    donors: "7",
    created: "May 20, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/gpdym-from-east-to-west",
  },
  {
    cur: 201,
    goal: 5000,
    donors: "5",
    created: "May 12, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/apac-arts-fundraiser",
  },
  {
    cur: 115,
    goal: 300,
    donors: "4",
    created: "April 21, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/znwx43-help-stop-asian-hate",
  },
  {
    cur: 8125,
    goal: 7350,
    donors: "174",
    created: "June 29, 2021",
    section: "Uplift",
    url: "https://www.gofundme.com/f/help-kim-owner-of-hanoi-kitchen-stay-open",
  },
  {
    cur: 9618,
    goal: 20000,
    donors: "137",
    created: "July 1, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/saving-the-oldest-chinese-restaurant-in-chinatown",
  },
  {
    cur: 9471,
    goal: 30000,
    donors: "47",
    created: "May 2, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/sokoji-preservation",
  },
  {
    cur: 6815,
    goal: 1300,
    donors: "116",
    created: "April 21, 2021",
    section: "Support",
    url: "https://www.gofundme.com/f/repair-murals-jack-kerouac-alley-hate-crime",
  },
  {
    cur: 4224,
    goal: 10000,
    donors: "62",
    created: "June 1, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/HelpSFChinatown",
  },
  {
    cur: 2620,
    goal: 2000,
    donors: "46",
    created: "May 22, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/support-oakland-chinatown-families-hurt-by-covid19",
  },
  {
    cur: 905,
    goal: 15000,
    donors: "9",
    created: "June 8, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/beautify-sf-chinatown-wentworth-alley",
  },
  {
    cur: 200,
    goal: 2000,
    donors: "3",
    created: "March 28, 2021",
    section: "Support",
    url: "https://www.gofundme.com/f/japantown-lions-2021-fundraiser",
  },
  {
    cur: 90165,
    goal: 30000,
    donors: "1.4K",
    created: "February 28, 2021",
    section: "Support",
    url: "https://www.gofundme.com/f/higashi",
  },
  {
    cur: 32661,
    goal: 5000,
    donors: "1.2K",
    created: "May 3, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/help-one-man-band-arthurs-rent-payments",
  },
  {
    cur: 8092,
    goal: 25000,
    donors: "138",
    created: "April 27, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/hop-woo-chinatown-fund",
  },
  {
    cur: 5091,
    goal: 50000,
    donors: "36",
    created: "May 5, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/chinatown-hot-meal-for-seniors",
  },
  {
    cur: 3500,
    goal: 20000,
    donors: "23",
    created: "August 25, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/zenshuji-temple-restoration",
  },
  {
    cur: 1000,
    goal: 1000,
    donors: "26",
    created: "June 1, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/20utn0jiao",
  },
  {
    cur: 775,
    goal: 5000,
    donors: "17",
    created: "June 9, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/help-little-tokyo-businesses-during-covid19",
  },
  {
    cur: 65669,
    goal: 65000,
    donors: "1.1K",
    created: "March 17, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/savenycchinatown-dumplings-against-hate",
  },
  {
    cur: 19973,
    goal: 26000,
    donors: "259",
    created: "October 29, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/light-up-chinatown",
  },
  {
    cur: 14122,
    goal: 10000,
    donors: "278",
    created: "February 28, 2021",
    section: "Support",
    url: "https://www.gofundme.com/f/yuckj3",
  },
  {
    cur: 12975,
    goal: 15000,
    donors: "222",
    created: "March 30, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/y43dk-send-chinatown-love",
  },
  {
    cur: 7167,
    goal: 10000,
    donors: "101",
    created: "April 4, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/yifangfundraising",
  },
  {
    cur: 5306,
    goal: 2500,
    donors: "129",
    created: "May 6, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/i-heart-chinatown-covid-relief-fund",
  },
  {
    cur: 5185,
    goal: 10000,
    donors: "85",
    created: "September 11, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/chinatownmuralproject",
  },
  {
    cur: 2710,
    goal: 2500,
    donors: "53",
    created: "May 6, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/support-a-nyc-chinatown-health-center-with-apamsa",
  },
  {
    cur: 2500,
    goal: 2500,
    donors: "40",
    created: "November 20, 2020",
    section: "Support",
    url: "https://www.gofundme.com/f/lets-bring-10-chinatown-businesses-online",
  },
  {
    cur: 2922970,
    goal: 20000,
    donors: "76.6K",
    created: "March 18, 2021",
    section: "Atlanta",
    url: "https://www.gofundme.com/f/in-memory-of-hyunjungkim-to-support-my-brother-i",
  },
  {
    cur: 383623,
    goal: 375000,
    donors: "12.1K",
    created: "March 17, 2021",
    section: "Atlanta",
    url: "https://www.gofundme.com/f/help-elcias-hernandez-ortiz-cover-medical-bills",
  },
  {
    cur: 222975,
    goal: 20000,
    donors: "5.6K",
    created: "March 19, 2021",
    section: "Atlanta",
    url: "https://www.gofundme.com/f/in-loving-memory-of-sun-cha-kim",
  },
  {
    cur: 178218,
    goal: 25000,
    donors: "4.1K",
    created: "March 20, 2021",
    section: "Atlanta",
    url: "https://www.gofundme.com/f/memorial-for-yong-yue-and-family",
  },
  {
    cur: 142361,
    goal: 20000,
    donors: "4.1K",
    created: "March 17, 2021",
    section: "Atlanta",
    url: "https://www.gofundme.com/f/funeral-and-family-financial-support",
  },
  {
    cur: 128567,
    goal: 30000,
    donors: "2.9K",
    created: "March 21, 2021",
    section: "Atlanta",
    url: "https://www.gofundme.com/f/atl-spa-shooting-family-survivor-fund-jami-webb",
  },
  {
    cur: 89114,
    goal: 15000,
    donors: "2.1K",
    created: "March 21, 2021",
    section: "Atlanta",
    url: "https://www.gofundme.com/f/for-husband-of-soon-c-park-victim-of-spa-shooting",
  },
  {
    cur: 81911,
    goal: 50000,
    donors: "2.5K",
    created: "March 18, 2021",
    section: "Atlanta",
    url: "https://www.gofundme.com/f/atlanta-spa-shooting-victim-paul-michels",
  },
  {
    cur: 44727,
    goal: 30000,
    donors: "784",
    created: "March 31, 2021",
    section: "Atlanta",
    url: "https://www.gofundme.com/f/help-as-funeral",
  },
  {
    cur: 12912,
    goal: 14000,
    donors: "303",
    created: "March 22, 2021",
    section: "Atlanta",
    url: "https://www.gofundme.com/f/cherokee-massage-parlor-survivor",
  },
];
